import { graphql } from '../gql';

export const reconstructionEvents = graphql(`
  subscription reconstructionEvents($session: String!, $gender: Population!) {
    reconstruction(session: $session) {
      ... on Reconstruction {
        scan {
          meshes {
            leftFoot
            rightFoot
          }
          measurement {
            leftLength
            leftWidth
            leftInstepHeight
            rightLength
            rightWidth
            rightInstepHeight
            compareToPopulation(population: $gender) {
              leftLength
              leftWidth
              leftInstepHeight
              rightLength
              rightWidth
              rightInstepHeight
            }
          }
          createdAt
          id
          publicID
          ... on WebScan {
            claimed
          }
        }
      }
      ... on ReconstructionError {
        message
        code
      }
    }
  }
`);
